// extracted by mini-css-extract-plugin
export default {"cls1":"UserTooltip-cls1__mm","cls2":"UserTooltip-cls2_g7i UserTooltip-cls1__mm"};